export default function FooterComponent() {
    return(
        <div>
            <div className='mt-5'>
                <p style={{fontSize:"14px"}}>© 2023 - Meinanto Tri Yuriawan</p>
            </div>
        </div>
    )
}